import { createRoot } from 'react-dom/client';
import { Gate } from './editor/Gate.tsx';
import './editor/styles.css';

createRoot(document.getElementById('root')!).render(<Gate />);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}));
}
